<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class="flex">
        <el-select
          v-if="theUserProject == 0"
          v-model="theProjectId"
          @change="theProjectAllChange"
          size="small"
          clearable
          placeholder="请选择项目"
        >
          <el-option
            v-for="item in getProjectList_data.data || []"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          >
          </el-option>
        </el-select>
        <el-cascader
          ref="cascader2"
          v-model="theBcId"
          clearable
          filterable
          size="small"
          collapse-tags
          placeholder="请选择业务"
          :show-all-levels="false"
          :options="
            getBusinessClassList_data ? getBusinessClassList_data.data : []
          "
          :props="propsTwo"
          style="width: 300px;"
        >
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{
              data.bcName
            }}</span>
          </template>
        </el-cascader>
        <el-select
          v-model="getType"
          clearable
          placeholder="请选择时间段"
          size="small"
          style="max-width:150px;"
          @change="getData"
        >
          <el-option label="总" :value="1"></el-option>
          <el-option label="今日" :value="2"></el-option>
          <el-option label="本周" :value="3"></el-option>
          <el-option label="月" :value="4"></el-option>
        </el-select>
        <el-date-picker
          v-model="valueDate"
          size="small"
          type="daterange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="timeChange"
          value-format="yyyy-MM-dd"
          align="right"
        >
        </el-date-picker>
        <el-button
          @click="getData"
          type="primary"
          icon="el-icon-search"
          size="small"
          style="margin-left:10px;"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="6"> </el-col>
    </el-row>

    <mytable
      :tableColums="tableColums_getStatisticsOpportunity"
      api="getStatisticsOpportunity"
      updateapi="updateMicrolectureTypeMain"
      :height="H - 165"
    >
    </mytable>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import aplayer from "vue-aplayer";
import echarts from "echarts";
export default {
  components: {
    aplayer
  },
  data() {
    let self = this;
    return {
        theBcId:'',
      propsTwo: {
        expandTrigger: "click",
        checkStrictly: true,
        emitPath: false,
        label: "bcName",
        value: "bcId",
        children: "children",
        multiple: true,
        lazy: true,
        lazyLoad(node, resolve) {
          console.log(node);
          const { level } = node;
          console.log(level);
          self
            .getBusinessClassListTwo({ bcParentId: node.data.bcId })
            .result(res => {
              if (res.data.data) {
                console.log(level);
                const nodes = res.data.data.map(item => ({
                  bcId: item.bcId,
                  bcName: item.bcName,
                  leaf: level >= 2
                }));
                resolve(nodes);
              }
            });
        }
      },
      examType: "",
      valueDate: "",
      ymtmTimeSubmitStart: "",
      ymtmTimeSubmitEnd: "",
      dtId: "",
      baseUrl: $Api.baseUrl_online,
      audio2: [],
      audioShow: false,
      audio: null,
      color: [
        " #4992ff",
        " #dd79ff",
        " #fddd60",
        "  #ff6e76",
        " #58d9f9",
        " #05c091",
        "  #ff8a45",
        " #8d48e3"
      ],
      echartsStr: "",
      echartsStrValue: [],
      getType: "",
      microlectureTitle: "",
      getMicrolectureTypeMainList_data: [],
      theUserProject: "",
      theProjectId: "",
      detailArr: [],
      viedoDet: false,
      mtmId: null,

      tableColums_getStatisticsOpportunity: {
        $selection: false,

        dtName: "战队",

        userBusinessNum: "业务数量",
        userOrderNum: "订单数量",
        userKpi: "签约金额",
        userPosition: "排名"
      }
    };
  },

  watch: {},

  methods: {
    theDtChange(e) {
      this.dtId = e;
      this.$refs.cascader.dropDownVisible = false;
      this.getData();
    },
    timeChange(e) {
      if (e) {
        this.startDate = e[0];
        this.endDate = e[1];
      } else {
        this.startDate = "";
        this.endDate = "";
      }
      this.getData();
    },

    onEnded() {
      this.audio2 = [];
      this.audioShow = false;
    },
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getData();
    },
    getData() {
      this.getStatisticsOpportunity({
        projectId: this.theProjectId,
        getType: this.getType,
        startDate: this.startDate,
        endDate: this.endDate,
        bcIds:this.theBcId ? this.theBcId.toString():'',
        currentPage: 1
      });
    }
  },

  async created() {
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject == 0) {
      this.getProjectList({
        pageSize: 0
      });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getStatisticsOpportunity({ projectId: A.local("$projectId") });
    this.getBusinessClassList({ bcParentId: 0 });
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/data/orderData.vue